import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import HighchartsReact from 'highcharts-react-official';
import * as Highcharts from 'highcharts';
import {Card, CardContent} from '@mui/material';
import {COLORS} from '@/utils/constants';
import {getDefaultPieFormatting} from '../../charts/pie';

interface Props {
	baseline: any[];
}

const QUESTIONS = [
	'question12',
	'question29',
	'question32',
	'question35',
	'question38',
	'question41',
	'question44',
	'question47',
	'question50',
	'question53',
	'question56',
	'question59',
];

const ObtainedFunds = ({baseline}: Props) => {
	const chartComponentRef = useRef<HighchartsReact.RefObject>(null);
	const [options, setOptions] = useState<Highcharts.Options>();

	const calculateSubmissions = () => {
		let success = 0;
		let pending = 0;
		let unSuccess = 0;

		baseline.forEach((submission: any) => {
			QUESTIONS.forEach((question: string) => {
				if (submission[question] === 'Item 1') {
					success += 1;
				} else if (submission[question] === 'Item 2') {
					pending += 1;
				} else if (submission[question] === 'Item 3') {
					unSuccess += 1;
				}
			})
		})

		const data = [
			{
				name: 'Yes',
				y: success,
				color: COLORS.blue,
			},
			{
				name: 'Pending',
				y: pending,
				color: COLORS.yellow,
			},
			{
				name: 'No',
				y: unSuccess,
				color: COLORS.gray,
			},
		];
		const title = '% of entrepreneurs who obtained funds before the acceleration program';
		const dashboardOptions: any = getDefaultPieFormatting(title, data);

		setOptions(dashboardOptions);
	};

	useEffect(() => {
		calculateSubmissions();
	}, []);

	return (
		<Card className='chart-container'>
			<CardContent>
				{options && (
					<HighchartsReact
						highcharts={Highcharts}
						options={options}
						ref={chartComponentRef}
					/>
				)}
			</CardContent>
		</Card>
	);
};

export default ObtainedFunds;
